import { EntityAction, EntityCollection, EntityCollectionReducerMethodMap, EntityCollectionReducerMethods, EntityDefinitionService } from 'ngrx-data';
import { Injectable } from '@angular/core';
import { ResponseMapper } from '@kaiser-software/chassis-resource/src/utils/response-mapper';

export class ChassisEntityCollectionReducerMethods<T> extends EntityCollectionReducerMethods<T> {

    /**
     * Merges query results per the MergeStrategy
     * Sets loading flag to false and loaded flag to true.
     */
    protected queryAllSuccess(collection: EntityCollection<T>, action: EntityAction<T[]>): EntityCollection<T> {

        const data          = this.extractData(action)['resources'].map(resource => ResponseMapper.fromGetRequest(resource));
        const mergeStrategy = this.extractMergeStrategy(action);

        return {
            ...this.entityChangeTracker.mergeQueryResults(data, collection, mergeStrategy),
            loaded: true,
            loading: false
        };
    }

    protected queryManySuccess(collection: EntityCollection<T>, action: EntityAction<T[]>): EntityCollection<T> {

        const data          = this.extractData(action)['resources'].map(resource => ResponseMapper.fromGetRequest(resource));
        const mergeStrategy = this.extractMergeStrategy(action);

        return {
            ...this.entityChangeTracker.mergeQueryResults(data, collection, mergeStrategy),
            loading: false
        };
    }

}

/**
 * Creates {EntityCollectionReducerMethods} for a given entity type.
 */
@Injectable()
export class ChassisEntityCollectionReducerMethodsFactory {
    constructor(private entityDefinitionService: EntityDefinitionService) {
    }

    /** Create the  {EntityCollectionReducerMethods} for the named entity type */
    create<T>(entityName: string): EntityCollectionReducerMethodMap<T> {
        const definition   = this.entityDefinitionService.getDefinition<T>(entityName);
        const methodsClass = new ChassisEntityCollectionReducerMethods(entityName, definition);

        return methodsClass.methods;
    }
}



// WEBPACK FOOTER //
// ./libs/chassis-resource/src/services/chassis-entity-collection-reducer-methods-factory.ts